module.exports = __webpack_public_path__ + "static/media/banner.19245e6e.png";